import React from "react";

import * as d3 from "d3";
import moment from "moment";

import {
  timeFormats,
  timeframeToRange
} from "src/organization/pages/project/environment/metrics/components/Chart/settings";
import { useHttpMetricsContext } from "src/organization/pages/project/environment/metrics/http/context";
import {
  CurserDataType,
  PageTimeFrameType
} from "src/organization/pages/project/environment/metrics/http/types";

import * as S from "./style";

type SeekTimeType = {
  yScale: d3.ScaleLinear<any, any>;
  cursorData?: CurserDataType;
};

const getSeekedTime = ({
  timeframe,
  timestamp
}: {
  timeframe?: PageTimeFrameType;
  timestamp: Date;
}) => {
  const range = timeframeToRange(timeframe);
  const hours = moment(range.end).diff(range.start, "hours");
  return hours > 24
    ? timeFormats.tooltipLong(timestamp)
    : timeFormats.tooltip(timestamp);
};

const TimeSeek = (props: SeekTimeType) => {
  const timeframe = useHttpMetricsContext()?.timeframe;

  const { yScale, cursorData } = props;
  const [y1, y2] = [yScale.range()[0], yScale.range()[1]];

  const seekedTime = cursorData?.xInvert
    ? getSeekedTime({
        timeframe,
        timestamp: cursorData.xInvert
      })
    : null;

  const isLongLabel = (seekedTime?.length || 0) > 8;

  return (
    <g
      visibility={cursorData ? "visible" : "hidden"}
      y1={y1}
      y2={y2}
      transform={`translate(${cursorData?.relativeX || 0}, ${0})`}
    >
      <S.StrokeLine className="stroke-line" y1={y1} y2={y2} />
      <S.SeekTimeContainer
        transform={`translate(${isLongLabel ? -45 : -23}, ${y1 + 5})`}
        width={isLongLabel ? 90 : 46}
        height="15"
        rx="1"
        ry="1"
        fillOpacity="1"
      />
      <S.SeekTimeText
        dominantBaseline="middle"
        textAnchor="middle"
        transform={`translate(${0}, ${y1 + 14})`}
      >
        {seekedTime}
      </S.SeekTimeText>
    </g>
  );
};

export default TimeSeek;
